// import React, { useState, useEffect } from 'react'
// import logo1 from '../../StudentRegristrationDesign/jain logo.png'
// import { Popover, TextField, Typography } from '@mui/material'
// import { FaUserCircle } from 'react-icons/fa'
// import { AiOutlineLogout } from 'react-icons/ai'
// import { RiLockPasswordFill } from 'react-icons/ri'
// import { Col, Row, Spinner } from 'react-bootstrap'
// import { useNavigate } from 'react-router-dom'
// import Footer from './Footer'
// // import FooterAll from '../../FooterAll'

// const Header = () => {
//   const memberId = sessionStorage.getItem('member_id')
//   const memberName = sessionStorage.getItem('memberName')
//   const email = sessionStorage.getItem('email')

//   const [anchorEl, setAnchorEl] = React.useState(null)
//   const handleClickPopover = (event) => {
//     setAnchorEl(event.currentTarget)
//   }
//   const handleClosePopover = () => {
//     setAnchorEl(null)
//   }
//   const open2 = Boolean(anchorEl)
//   const id = open2 ? 'simple-popover' : undefined

//   const navigate = useNavigate()
//   const logoutFun = () => {
//   const confirmLogout = window.confirm("Are you sure you want to logout?");
//   if (confirmLogout) {
//     sessionStorage.clear();
//     navigate('/');
//   }
// };
//   const handlePasswordChange = () => {
//     navigate('/passwordChangeStudent')
//   }

//   return (
//     <>
//       <Row
//         className="py-1 m-0 p-0 pe-2 py-3 nav-logo-fixed"
//         style={{ display: 'flex', backgroundColor: '#0783d6' }}
//       >
//         <Col
//           sm={8}
//           md={7}
//           lg={8}
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'start',
//           }}
//         >
//           {/* <img
//             src={logo1}
//             alt="Logo"
//             style={{ mixBlendMode: 'darken',height:"100px" }}
//           /> */}
//           <span style={{fontSize:"24px",color:"white"}}>Sheth R. D. Davada Digambar Jain Boarding, Sangli.</span>

//         </Col>
//         <Col
//           sm={2}
//           md={5}
//           lg={4}
//           className="pe-0"
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'end',
//             fontSize:"18px",color:"white"
//           }}
//         >
//         {memberName} &nbsp; &nbsp;
//           <FaUserCircle
//             style={{ fontSize: 30, color: 'white' }}
//             title="Profile"
//             aria-describedby={id}
//             variant="contained"
//             onClick={handleClickPopover}
//           />
//           <Popover
//             id={id}
//             open={open2}
//             anchorEl={anchorEl}
//             onClose={handleClosePopover}
//             anchorOrigin={{
//               vertical: 'bottom',
//               horizontal: 'left',
//             }}
//           >
//             <Typography className="w-100 text-end">
//               {' '}
//               <button
//                 className="w-100 text-end"
//                 style={{
//                   backgroundColor: 'white',
//                   color: 'black',
//                   borderRadius: '0px',
//                 }}
//               >
//                 {memberName} &nbsp; <FaUserCircle />
//               </button>{' '}
//             </Typography>
//             <Typography className="w-100 text-end">
//               {' '}
//               <button
//                 className="w-100 text-end"
//                 style={{
//                   backgroundColor: 'white',
//                   color: 'black',
//                   borderRadius: '0px',
//                 }}
//                 onClick={handlePasswordChange}
//               >
//                 Change Password &nbsp; <RiLockPasswordFill />
//               </button>{' '}
//             </Typography>
//             <Typography className="w-100 text-end">
//               {' '}
//               <button
//                 className="w-100 text-end"
//                 style={{
//                   backgroundColor: 'white',
//                   color: 'black',
//                   borderRadius: '0px',
//                 }}
//                 onClick={logoutFun}
//               >
//                 Logout &nbsp;
//                 <AiOutlineLogout />
//               </button>{' '}
//             </Typography>
//           </Popover>
          
//         </Col>
//       </Row>
//     </>
//   )
// }

// export default Header


import React from 'react'
import logo1 from '../../StudentRegristrationDesign/jain logo.png'
import { Popover, Typography } from '@mui/material'
import { FaUserCircle } from 'react-icons/fa'
import { AiOutlineLogout } from 'react-icons/ai'
import { RiLockPasswordFill } from 'react-icons/ri'
import { Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const Header = () => {
  const memberId = sessionStorage.getItem('member_id')
  const memberName = sessionStorage.getItem('memberName')
  const email = sessionStorage.getItem('email')

  const [anchorEl, setAnchorEl] = React.useState(null)
  const navigate = useNavigate()

  const handleClickPopover = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  const open2 = Boolean(anchorEl)
  const id = open2 ? 'simple-popover' : undefined

  const logoutFun = () => {
    const confirmLogout = window.confirm('Are you sure you want to logout?')
    if (confirmLogout) {
      sessionStorage.clear()
      navigate('/')
    }
  }

  const handlePasswordChange = () => {
    navigate('/passwordChangeStudent')
  }

  return (
    <>
      <Row
        className="py-3 m-0 p-0 nav-logo-fixed"
        style={{
          alignItems: 'center',
          backgroundColor: '#0783d6',
          color: 'white',
        }}
      >
        {/* LEFT SIDE (BOARDING NAME) */}
        <Col
          xs={12}
          md={2}
          lg={1}
          className="text-md-start text-center"
        >
          {/* MOBILE LOGO */}
          <div className="mb-2">
            <img
              src={logo1}
              alt="Logo"
              style={{ height: '90px',backgroundColor:"#a2d6f8",borderRadius:"50%" }}
            />
          </div>
        </Col>

        <Col
          xs={12}
          md={5}
          lg={7}
          className="text-md-start text-center"
        >
          <span
            style={{
              fontSize: '25px',
              fontWeight: '500',
              lineHeight: '1.3',
              color: 'white',
            }}
          >
            Sheth R. D. Davada Digambar Jain Boarding, Sangli.
          </span>
        </Col>

        {/* RIGHT SIDE (MEMBER NAME + ICON) */}
        <Col
          xs={12}
          md={5}
          lg={4}
          className="text-md-end text-center mt-3 mt-md-0"
          style={{
            fontSize: '18px',
            color: 'white',
          }}
        >
          {memberName} &nbsp;&nbsp;
          <FaUserCircle
            style={{ fontSize: 30, color: 'white', cursor: 'pointer' }}
            title="Profile"
            aria-describedby={id}
            onClick={handleClickPopover}
          />
          <Popover
            id={id}
            open={open2}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Typography className="w-100 text-end">
              <button
                className="w-100 text-end"
                style={{
                  backgroundColor: 'white',
                  color: 'black',
                  borderRadius: '0px',
                }}
              >
                {memberName} &nbsp; <FaUserCircle />
              </button>
            </Typography>
            <Typography className="w-100 text-end">
              <button
                className="w-100 text-end"
                style={{
                  backgroundColor: 'white',
                  color: 'black',
                  borderRadius: '0px',
                }}
                onClick={handlePasswordChange}
              >
                Change Password &nbsp; <RiLockPasswordFill />
              </button>
            </Typography>
            <Typography className="w-100 text-end">
              <button
                className="w-100 text-end"
                style={{
                  backgroundColor: 'white',
                  color: 'black',
                  borderRadius: '0px',
                }}
                onClick={logoutFun}
              >
                Logout &nbsp; <AiOutlineLogout />
              </button>
            </Typography>
          </Popover>
        </Col>
      </Row>
    </>
  )
}

export default Header
